var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-more-data",style:({
    height: _vm.main ? "72px" : "40px",
    padding: _vm.main ? "16px" : "0px"
  })},[_c('div',{staticClass:"main"},[_vm._t("default",[_vm._v("~ (￣▽￣) ~ 没有更多了~")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }